import { render } from "./UnavailabilityCard.vue?vue&type=template&id=aedde884&ts=true"
import script from "./UnavailabilityCard.vue?vue&type=script&lang=ts"
export * from "./UnavailabilityCard.vue?vue&type=script&lang=ts"

import "./UnavailabilityCard.vue?vue&type=style&index=0&id=aedde884&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__